import { AiFeedSidebarPage } from "@/features/AiFeed/AiFeedSidebarPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/ai-feed")({
  component: RouteComponent,
});

function RouteComponent() {
  return <AiFeedSidebarPage />;
}
